export enum ContractTitle {
  Funded = 'funded_contract',
  FundedRules = 'funded_rules',
  Affiliation = 'affiliation_contract',
  Nyse = 'nyse',
}
